import { updateLocale, loadLanguagePack } from '@americanexpress/one-app-ducks';
import { DEFAULT_LOCALE } from '@americanexpress/amex-connect-core';

export const MODULE_NAME = 'amex-connect-root';

export const loadLocale = (locale) => async (dispatch) => {
  await dispatch(updateLocale(locale));
  await dispatch(loadLanguagePack(MODULE_NAME, { fallbackLocale: DEFAULT_LOCALE }));
};
